<template>
  <v-container fluid>
    <!-- Card Management -->
    <v-card class="mb-4">
      <v-card-title>
        <v-row align="center" justify="space-between" class="w-100">
          <span>💳 My Card</span>
          <v-btn icon @click="freezeCard"><v-icon>mdi-lock</v-icon></v-btn>
          <v-btn icon @click="viewPin"><v-icon>mdi-eye</v-icon></v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-img src="/card-visual.png" aspect-ratio="2.5"></v-img>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn icon><v-icon>mdi-swap-horizontal</v-icon></v-btn> Transfers
            <v-btn icon><v-icon>mdi-history</v-icon></v-btn> History
            <v-btn icon><v-icon>mdi-bank-transfer-in</v-icon></v-btn> Deposit
            <v-btn icon><v-icon>mdi-finance</v-icon></v-btn> Financial
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Financial Summary -->
    <v-card class="mb-4">
      <v-card-title>📊 Financial Summary</v-card-title>
      <v-card-text>
        <v-row>
          <v-col><v-chip color="green" text-color="white">Income: $9000 ↑</v-chip></v-col>
          <v-col><v-chip color="red" text-color="white">Expenses: $600 ↓</v-chip></v-col>
        </v-row>
        <v-select
          v-model="selectedFilter"
          :items="['All', 'Supermarket', 'Health', 'Transfers']"
          label="Filter by Category"
        />
        <v-list>
          <v-list-item v-for="tx in filteredTransactions" :key="tx.id">
            <v-list-item-content>{{ tx.label }}</v-list-item-content>
            <v-list-item-action>{{ tx.amount }}</v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <!-- Bar Chart Analytics -->
    <v-card class="mb-4">
      <v-card-title>📈 Analytics</v-card-title>
      <v-card-text>
        <v-btn-toggle v-model="chartView" mandatory>
          <v-btn value="day">Day</v-btn>
          <v-btn value="week">Week</v-btn>
          <v-btn value="month">Month</v-btn>
          <v-btn value="year">Year</v-btn>
        </v-btn-toggle>
        <!-- Placeholder for chart -->
        <div class="mt-4">[Bar Chart Component Here]</div>
      </v-card-text>
    </v-card>

    <!-- Pie Chart Analytics -->
    <v-card class="mb-4">
      <v-card-title>📊 Profit Breakdown</v-card-title>
      <v-card-text>
        <!-- Placeholder for donut chart -->
        <div class="mt-4">[Donut Chart Component Here]</div>
        <v-list>
          <v-list-item v-for="cat in categories" :key="cat.name">
            <v-icon left>{{ cat.icon }}</v-icon>
            <v-list-item-content>{{ cat.name }} - {{ cat.percent }}%</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <!-- Line & Bar Graphs -->
    <v-card class="mb-4">
      <v-card-title>📉 Profit Over Time</v-card-title>
      <v-card-text>
        <v-date-picker v-model="dateRange" range></v-date-picker>
        <!-- Placeholder for line/bar chart -->
        <div class="mt-4">[Line/Bar Chart Component Here]</div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      selectedFilter: 'All',
      chartView: 'month',
      dateRange: null,
      transactions: [
        { id: 1, label: 'Supermarket', amount: '-$140' },
        { id: 2, label: 'Health & Beauty', amount: '-$225' },
        { id: 3, label: 'Transfer from Card', amount: '+$300' },
        { id: 4, label: 'Cafes & Restaurants', amount: '-$105' }
      ],
      categories: [
        { name: 'Food', percent: 35, icon: 'mdi-food' },
        { name: 'Health', percent: 25, icon: 'mdi-heart' },
        { name: 'Transfers', percent: 40, icon: 'mdi-swap-horizontal' }
      ]
    }
  },
  computed: {
    filteredTransactions() {
      if (this.selectedFilter === 'All') return this.transactions
      return this.transactions.filter(tx => tx.label.includes(this.selectedFilter))
    }
  },
  methods: {
    freezeCard() {
      alert('Card frozen')
    },
    viewPin() {
      alert('PIN is hidden for security')
    }
  }
}
</script>

<style scoped>
.v-card {
  transition: all 0.3s ease;
}
.v-btn {
  margin: 4px;
}
</style>
